import React, { Component } from 'react'
// import classes from './Form.scss'
import InputGroup from '../../../UI/Forms/InputGroup/InputGroup'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Shake from '../../../Animation/Shake/Shake'

class form extends Component {
  state = {
    form: [],
    modalOpen: false,
    color: '#000000',
    width: 20
  }

  static getDerivedStateFromProps = (props, state) => {}

  checkValue = id => {
    let gradeItem = this.props.grade.find(item => {
      return item.grade_id === id
    })
    return gradeItem ? gradeItem.budget_percent : ''
  }
  checkTotal = () => {
    let sum = 0
    this.props.grade.map(item => {
      sum = sum + (+item?.budget_percent || 0)
      return item
    })
    return sum === 100
  }
  render() {
    let tabContent = null
    const StyledTableCell = withStyles(() => ({
      head: {
        backgroundColor: '#3f51b5',
        color: 'white'
      },
      body: {
        fontSize: 14
      }
    }))(TableCell)
    let inputgroup = Object.entries(this.props.inputGroups).map(res => {
      let [key, attr] = res
      return (
        <Grid item xs={12} md={3}>
          <InputGroup
            key={key}
            label={attr.label}
            inputType={attr.elementType}
            configs={attr.elementConfig}
            invalid={!attr.valid}
            validations={attr.validation}
            touched={attr.touched}
            changed={e => this.props.inputChanged(key, e)}
            inputValue={attr.value}
            validationError={attr.error}
          />
        </Grid>
      )
    })

    if (this.props.gradeData.length > 0) {
      tabContent = (
        <Grid container justify='center' alignItems='center'>
          <Grid item xs={12}>
            <Grid container direction='row' justify='space-evenly' alignItems='center' spacing={2}>
              {inputgroup}
            </Grid>
          </Grid>
          <Grid item xs={12} md={10}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell align='center'>Grade</StyledTableCell>
                  <StyledTableCell align='center'>Percent Budget</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  {!this.checkTotal() ? (
                    <TableCell colSpan={2} align='center' style={{ color: 'red' }}>
                      <Shake>{this.props.translate('totalGradeValidationText')}</Shake>
                    </TableCell>
                  ) : null}
                </TableRow>
                {this.props.gradeData.map(grade => (
                  <TableRow>
                    <TableCell align='center'>{grade.value_list_name}</TableCell>
                    <TableCell>
                      {/* gradeChanged */}
                      <InputGroup
                        changed={e => this.props.gradeChanged(grade.value_list_id, e)}
                        inputValue={this.checkValue(grade.value_list_id)}
                        configs={{
                          type: 'number',
                          inputProps: {
                            style: { textAlign: 'right' }
                          }
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      )
    }
    return <Aux>{tabContent}</Aux>
  }
}

export default withTranslate(form)
